import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { IClauseForTable } from "src/app/domain/interfaces/clause.interface";

@Component({
	selector: "app-clause-table",
	templateUrl: "./clause-table.component.html"
})
export class ClauseTableComponent {
	@Input() clauses: [IClauseForTable];
	@Input() onlyRead = false;
	@Input() proposalSummary = false;
	@Output() controlCheckedItem = new EventEmitter<any>();

	checkedItem(event: MatCheckboxChange, id: number): void {
		event.source.checked = false;
		this.controlCheckedItem.emit(id);
	}

	showAllText(item: IClauseForTable) {
		item.showTextPart = item.showTextPart ? false : true;
		item.showTextPartDesc = item.showTextPart ? "VER MAIS" : "VER MENOS";
	}
}
